import { render, staticRenderFns } from "./DocTableauDeBord.vue?vue&type=template&id=6164e348&"
import script from "./DocTableauDeBord.vue?vue&type=script&lang=js&"
export * from "./DocTableauDeBord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports